import { render } from "./SignedFileDownloadButton.vue?vue&type=template&id=4c230fe0"
import script from "./SignedFileDownloadButton.vue?vue&type=script&lang=js"
export * from "./SignedFileDownloadButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__